export default __webpack_public_path__ + "static/media/white-floor-car-parking.e4586a55.png";